import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useI18n } from "../i18n";


function Contact() {
    const { t } = useI18n();

    return (

        <>
            <>
                <Header />

                <>
                    {/* Page Header Section Start */}
                    <div className="page-header bg-section parallaxie">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    {/* Page Header Box Start */}
                                    <div className="page-header-box">
                                        <h1 className="text-anime-style-3" data-cursor="-opaque">{t('pages.contactTitle')}</h1>
                                  
                                    </div>
                                    {/* Page Header Box End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page Header Section End */}
                    {/* Page Contact Us Start */}
                    <div className="page-contact-us">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-4">
                                    {/* Contact Us Content Start */}
                                    <div className="contact-us-content">
                                        {/* Section Title Start */}
                                        <div className="section-title">
                                            <h3 className="wow fadeInUp">{t('pages.contactH3')}</h3>
                                            <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.contactH2')}</h2>
                                            <p className="wow fadeInUp" data-wow-delay="0.2s">{t('pages.contactIntroP')}</p>
                                        </div>
                                        {/* Section Title End */}
                                        {/* Contact Social List Start */}
                                        <div
                                            className="contact-social-links wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <ul>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-dribbble" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-linkedin-in" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fa-brands fa-instagram" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* Contact Social List End */}
                                    </div>
                                    {/* Contact Us Content End */}
                                </div>
                                <div className="col-xl-8">
                                    {/* Contact Info List Start */}
                                    <div className="contact-info-list">
                                        {/* Contact Info Item Start */}
                                        <div className="contact-info-item wow fadeInUp">
                                            <div className="icon-box">
                                                <img src="images/icon-phone-white.svg" alt="" />
                                            </div>
                                            <div className="contact-item-content">
                                                <p>{t('pages.contactLabelPhone')}</p>
                                                <h3>
                                                    <a href="tel:123456789">+(91) 9124702436</a>
                                                </h3>
                                            </div>
                                        </div>
                                        {/* Contact Info Item End */}
                                        {/* Contact Info Item Start */}
                                        <div
                                            className="contact-info-item wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="icon-box">
                                                <img src="images/icon-mail-white.svg" alt="" />
                                            </div>
                                            <div className="contact-item-content">
                                                <p>{t('pages.contactLabelEmail')}</p>
                                                <h3>
                                                    <a href="mailto:info@konarkpathautsav.com">info@konarkpathautsav.com</a>
                                                </h3>
                                            </div>
                                        </div>
                                        {/* Contact Info Item End */}
                                        {/* Contact Info Item Start */}
                                        <div
                                            className="contact-info-item location-item wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div className="icon-box">
                                                <img src="images/icon-location-white.svg" alt="" />
                                            </div>
                                            <div className="contact-item-content">
                                                <p>{t('pages.contactLabelAddress')}</p>
                                                <h3>
                                                C/O- Rajkishore Mohapatra ,Infront of Forest Office ,PIN-752111 Konark
                                                </h3>
                                            </div>
                                        </div>
                                        {/* Contact Info Item End */}
                                    </div>
                                    {/* Contact Info List End */}
                                </div>
                                <div className="col-lg-12">
                                    {/* Contact Form Map Start */}
                                    <div className="contact-form-map">
                                        {/* Contact Us Form Start */}
                                        <div className="contact-us-form dark-section">
                                            {/* Section Title Start */}
                                            <div className="section-title">
                                                <h2 className="text-anime-style-3" data-cursor="-opaque">{t('pages.contactFormTitle')}</h2>
                                            </div>
                                            {/* Section Title End */}
                                            {/* Contact Form Start */}
                                            <div className="contact-form">
                                                <form
                                                    id="contactForm"
                                                    action="#"
                                                    method="POST"
                                                    data-toggle="validator"
                                                    className="wow fadeInUp"
                                                    data-wow-delay="0.2s"
                                                >
                                                    <div className="row">
                                                        <div className="form-group col-md-6 mb-4">
                                                            <input
                                                                type="text"
                                                                name="fname"
                                                                className="form-control"
                                                                id="fname"
                                                                placeholder="First name"
                                                                required=""
                                                            />
                                                            <div className="help-block with-errors" />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <input
                                                                type="text"
                                                                name="lname"
                                                                className="form-control"
                                                                id="lname"
                                                                placeholder="Last name"
                                                                required=""
                                                            />
                                                            <div className="help-block with-errors" />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                className="form-control"
                                                                id="email"
                                                                placeholder="E-mail"
                                                                required=""
                                                            />
                                                            <div className="help-block with-errors" />
                                                        </div>
                                                        <div className="form-group col-md-6 mb-4">
                                                            <input
                                                                type="text"
                                                                name="phone"
                                                                className="form-control"
                                                                id="phone"
                                                                placeholder="Phone"
                                                                required=""
                                                            />
                                                            <div className="help-block with-errors" />
                                                        </div>
                                                        <div className="form-group col-md-12 mb-5">
                                                            <textarea
                                                                name="message"
                                                                className="form-control"
                                                                id="message"
                                                                rows={3}
                                                                placeholder="Write message..."
                                                                defaultValue={""}
                                                            />
                                                            <div className="help-block with-errors" />
                                                        </div>
                                                        <div className="col-md-12">
                                                            <button type="submit" className="btn-default btn-highlighted">{t('labels.sendMessage')}</button>
                                                            <div id="msgSubmit" className="h3 hidden" />
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        {/* Contact Us Form End */}
                                        {/* Google Map Start */}
                                        <div className="google-map-iframe">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15007.203191436958!2d86.08082049278448!3d19.89063168155494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19ed591ff3c6b5%3A0x5ae97a04d50af18b!2sKonark%2C%20Odisha%20752111!5e0!3m2!1sen!2sin!4v1758607205406!5m2!1sen!2sin"
                                                allowFullScreen=""
                                                loading="lazy"
                                                referrerPolicy="no-referrer-when-downgrade"
                                            />
                                        </div>
                                        {/* Google Map End */}
                                    </div>
                                    {/* Contact Form Map End */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page Contact Us End */}
                </>


                <Footer />
            </>

        </>
    );
}

export default Contact;